export function getRetryWithdrawAmount({ balance, maxAmount } = {}) {
  const parsedBalance = Number(balance);
  const parsedMaxAmount = Number(maxAmount);

  if (!Number.isFinite(parsedBalance) || !Number.isFinite(parsedMaxAmount)) {
    return 0;
  }

  return Math.max(0, Math.min(parsedBalance, parsedMaxAmount));
}

export function isRetryWithdrawEventForSource({ sourceId, event } = {}) {
  return (
    Boolean(sourceId) &&
    event?.retryType === "withdraw" &&
    event?.sourceId === sourceId
  );
}
